import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20dramatic%20red%20curtains%20and%20warm%20golden%20spotlight%2C%20luxurious%20velvet%20seats%2C%20grand%20stage%2C%20atmospheric%20lighting%2C%20rich%20dark%20tones%20with%20gold%20accents%2C%20elegant%20cinema%20aesthetic&width=1800&height=900&seq=hero-banner-main&orientation=landscape"
        alt="八戒影院 - 最新影视资源同步更新"
        title="八戒影院 - 最新影视资源同步更新，热播剧新片上线抢先看不缓冲"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50" />
      <div className="absolute inset-0 flex flex-col items-center justify-center w-full px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 text-center leading-tight max-w-4xl">
          最新影视资源同步更新
          <br />
          <span className="text-primary-500">热播剧新片上线抢先看</span>
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-foreground-700 text-center max-w-2xl">
          汇聚免费电视剧全集与电影大全，高清在线流畅播放不缓冲。八戒影院持续为您提供最新最全的影视内容。
        </p>
        <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/movie"
            className="px-8 py-3 bg-primary-500 text-background-950 font-semibold rounded-full text-sm hover:bg-primary-400 transition-colors whitespace-nowrap"
          >
            立即观影
          </Link>
          <Link
            to="/category/tv"
            className="px-8 py-3 border border-foreground-700/40 text-foreground-800 font-semibold rounded-full text-sm hover:border-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            热播电视剧
          </Link>
        </div>
      </div>
    </section>
  );
}